import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Checklist} from '../../models/checklist.model';
import {map} from 'rxjs';
import {UrlService} from '../url.service';

@Injectable()
export class ChecklistService {
    private BASE_URL: string;

    constructor(private http: HttpClient,
                private urlService: UrlService) {
        this.BASE_URL = this.urlService.getBackendUrl() + 'data/checklists';
    }

    listModels(params) {
        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/models', requestOptions);
    }

    listChecklists(params) {
        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL, requestOptions);
    }

    createChecklist(checklistModelId, clientId, assessmentId) {
        let params = new HttpParams();
        params = params.set('checklistModelId', checklistModelId);
        if (clientId) {
            params = params.set('clientId', clientId);
        }
        if (assessmentId) {
            params = params.set('assessmentId', assessmentId);
        }

        const requestOptions = {
            params: params
        }

        return this.http.post(this.BASE_URL, {}, requestOptions);
    }

    getChecklist(checklistId) {
        return this.http.get(this.BASE_URL + '/' + checklistId).pipe(
            map((checklist: any) => {
                return new Checklist(checklist);
            })
        );
    }

    updateChecklist(checklist: Checklist) {
        return this.http.put(this.BASE_URL + '/' + checklist.id, checklist).pipe(
            map((checklist: any) => {
                return new Checklist(checklist);
            })
        );
    }

    markAnswerDone(checklistId: number, answerId: number) {
        return this.http.put(this.BASE_URL + '/' + checklistId + '/answers/' + answerId + '/done', {});
    }

    listAnswers(params) {
        const requestOptions = {
            params: params
        }

        return this.http.get(this.BASE_URL + '/answers', requestOptions);
    }
}
